import './SocialLogin.css';
import { PublicClientApplication } from '@azure/msal-browser';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Footer from '../components/Footer';

const MICROSOFT_AUTH_CLIENT_ID = '7ddb940a-351d-45e6-8c8e-de6cc1458160';
const REDIRECT_URI = 'https://autoforward.brili.tech/outlook';
const BACKEND_URL = 'https://backend-569133653378.asia-southeast2.run.app';

const msalConfig = {
	auth: {
		clientId: MICROSOFT_AUTH_CLIENT_ID,
	},
};

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

function Outlook() {
	const [loading, setLoading] = React.useState(false);
	const [searchParams] = useSearchParams();
	const encEmail = searchParams.get('encEmail');
	const navigate = useNavigate();

	const login = async () => {
		const resp = await msalInstance
			.loginPopup({
				redirectUri: REDIRECT_URI,
				scopes: [
					'offline_access',
					'user.read',
					'mail.read',
					'MailboxSettings.ReadWrite',
				],
			})
			.catch((e) => {
				console.log(e);
				if (e.message.includes('user_cancelled')) {
					return null;
				}
				return String(e.message);
			});
		console.log(resp);
		if (!resp) {
			return;
		}
		if (typeof resp === 'string') {
			navigate('/error', { state: { message: resp, type: 'outlook' } });
			return;
		}
		setLoading(true);

		const createMsgRuleResp = await fetch(`${BACKEND_URL}/api/msgRules/`, {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${resp.accessToken}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ encEmail }),
		});
		if (!createMsgRuleResp.ok) {
			navigate('/error', {
				state: { message: await createMsgRuleResp.text(), type: 'outlook' },
			});
			return;
		}
		navigate('/success', {
			state: { message: 'Outlook integrated successfully', type: 'outlook' },
		});
		setLoading(false);
	};

	return (
		<div>
			<div className="custom-card">
				<div className="custom-card-header-row">
					<h1 className="page-title">Welcome to Brilitech</h1>
					<img src="/brilitech-logo.png" alt="logo" className="logo-img" />
				</div>
				<div className="custom-card-header">
					<div className="custom-card-title">Outlook Integration</div>
				</div>
				<div className="custom-card-content">
					<p style={{ textAlign: 'center', marginBottom: 24 }}>
						To begin using our services, please connect your Outlook account.
					</p>
					<div className="info-box">
						<div className="info-box-title">What this integration does:</div>
						<ul>
							<li>
								Creates message rules to identify trade confirmation emails from
								your brokerage platform
							</li>
							<li>
								Labels and forwards only relevant brokerage emails to our secure
								system
							</li>
							<li>
								Enables automated monitoring and analysis of your trading
								activity
							</li>
						</ul>
					</div>
					<div className="privacy-box">
						<div className="privacy-title">Privacy Assurance</div>
						<div className="privacy-text">
							Only emails from verified brokerage platforms will be processed.
							Your personal correspondence remains private and will not be
							accessed or forwarded.
						</div>
					</div>
					<p style={{ textAlign: 'center', marginBottom: 24 }}>
						By clicking the button below, you consent to these permissions and
						agree to our terms of service.
					</p>
					<button onClick={login} className="connect-btn" disabled={loading}>
						{loading ? 'Connecting...' : 'Connect Outlook'}
						<span
							style={{
								marginLeft: 8,
								display: 'inline-flex',
								alignItems: 'center',
							}}
						>
							<svg
								width="20"
								height="20"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								strokeWidth="2"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M17 8l4 4m0 0l-4 4m4-4H3"
								/>
							</svg>
						</span>
					</button>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default Outlook;
